var zhCN = {
	"neptune.Button.loadingAriaLabel": "正在加载",
	"neptune.Chips.ariaLabel": "清除 {choice}",
	"neptune.ClearButton.ariaLabel": "清除",
	"neptune.CloseButton.ariaLabel": "关闭",
	"neptune.DateInput.day.label": "日",
	"neptune.DateInput.day.placeholder": "日",
	"neptune.DateInput.month.label": "月",
	"neptune.DateInput.year.label": "年",
	"neptune.DateInput.year.placeholder": "年",
	"neptune.DateLookup.day": "日",
	"neptune.DateLookup.goTo20YearView": "转到 20 年视图",
	"neptune.DateLookup.month": "月",
	"neptune.DateLookup.next": "下一页",
	"neptune.DateLookup.previous": "上一页",
	"neptune.DateLookup.selected": "已选",
	"neptune.DateLookup.twentyYears": "20 年",
	"neptune.DateLookup.year": "年",
	"neptune.FlowNavigation.back": "返回上一步",
	"neptune.Info.ariaLabel": "更多信息",
	"neptune.Label.optional": "（可选）",
	"neptune.Link.opensInNewTab": "（在新标签页中打开）",
	"neptune.MoneyInput.Select.placeholder": "请选择...",
	"neptune.MoneyInput.Select.selectCurrencyLabel": "选择货币",
	"neptune.PhoneNumberInput.SelectInput.placeholder": "选择其中一项...",
	"neptune.Select.searchPlaceholder": "搜索",
	"neptune.SelectInput.noResultsFound": "找不到结果",
	"neptune.SelectOption.action.label": "选择",
	"neptune.SelectOption.selected.action.label": "更改所选选项",
	"neptune.StatusIcon.iconLabel.error": "错误:",
	"neptune.StatusIcon.iconLabel.information": "信息:",
	"neptune.StatusIcon.iconLabel.pending": "待处理:",
	"neptune.StatusIcon.iconLabel.success": "成功:",
	"neptune.StatusIcon.iconLabel.warning": "警告：",
	"neptune.Summary.statusDone": "已完成",
	"neptune.Summary.statusNotDone": "未完成",
	"neptune.Summary.statusPending": "待处理",
	"neptune.Table.actionHeader": "操作",
	"neptune.Table.emptyData": "找不到结果",
	"neptune.Table.loaded": "表数据已加载",
	"neptune.Table.loading": "表数据正在加载",
	"neptune.Table.refreshPage": "刷新页面",
	"neptune.Upload.csButtonText": "上传另一个文件？",
	"neptune.Upload.csFailureText": "上传失败。请重试",
	"neptune.Upload.csSuccessText": "上传完毕！",
	"neptune.Upload.csTooLargeMessage": "请提供一个小于 {maxSize} MB 的文件",
	"neptune.Upload.csWrongTypeMessage": "不支持该文件类型，请试试其他文件",
	"neptune.Upload.psButtonText": "取消",
	"neptune.Upload.psProcessingText": "正在上传…",
	"neptune.Upload.retry": "重试",
	"neptune.Upload.usButtonText": "或选择文件",
	"neptune.Upload.usDropMessage": "拖放文件开始上传",
	"neptune.Upload.usPlaceholder": "拖放一个不超过 {maxSize} MB 的文件",
	"neptune.UploadButton.allFileTypes": "所有文件类型",
	"neptune.UploadButton.dropFiles": "拖放文件开始上传",
	"neptune.UploadButton.instructions": "{fileTypes}，小于 {size} MB",
	"neptune.UploadButton.maximumFiles": "最多 {maxFiles} 个文件。",
	"neptune.UploadButton.uploadFile": "上传文件",
	"neptune.UploadButton.uploadFiles": "上传文件",
	"neptune.UploadInput.deleteModalBody": "删除此文件会将其从我们的系统中删除",
	"neptune.UploadInput.deleteModalCancelButtonText": "取消",
	"neptune.UploadInput.deleteModalConfirmButtonText": "删除",
	"neptune.UploadInput.deleteModalTitle": "确定要删除此文件吗？",
	"neptune.UploadInput.fileIsTooLarge": "文件太大",
	"neptune.UploadInput.fileTypeNotSupported": "文件类型不受支持",
	"neptune.UploadInput.maximumFilesAlreadyUploaded": "抱歉，此上传失败，因为我们一次只能接受 {maxFilesAllowed} 个文件。",
	"neptune.UploadItem.deleting": "正在删除…",
	"neptune.UploadItem.removeFile": "删除文件 {filename}",
	"neptune.UploadItem.uploaded": "已上传",
	"neptune.UploadItem.uploadedFile": "上传的文件",
	"neptune.UploadItem.uploading": "正在上传…",
	"neptune.UploadItem.uploadingFailed": "上传失败"
};

export { zhCN as default };
//# sourceMappingURL=zh-CN.json.mjs.map
